<template>
  <div class="px-4 px-lg-12 py-12 d-flex flex-column align-center" style="height: 100%; width: 100%">
    <div class="text-h5 font-weight-bold mb-10 text-center">Register Your Institute</div>

    <v-form
      :style="{width: $vuetify.breakpoint.mdAndDown ? '100%': '75%'}"
      @submit.prevent="submit"
      lazy-validation
      ref="form"
      v-model="valid"
    >
      <v-text-field
        :rules="emailRules"
        name="email"
        outlined
        prepend-inner-icon="mdi-email"
        type="email"
        v-model="email"
      >
        <template #label>Email *</template>
      </v-text-field>
      <v-text-field
        :rules="phoneRules"
        name="phone"
        outlined
        prefix="+94"
        prepend-inner-icon="mdi-phone"
        type="telephone"
        v-model="phone"
      >
        <template #label>Phone Number *</template>
      </v-text-field>
      <v-btn :loading="isSubmitting" block class="mt-2" color="primary" large type="submit">Submit</v-btn>
    </v-form>
  </div>
</template>

<script>
import { rules } from "@/utils/validatorUtil";
import { instituteService } from "@/services";

export default {
  name: "ContactDetails",

  data: () => ({
    valid: true,
    email: "",
    phone: "",
    isSubmitting: false,
  }),

  computed: {
    rules() {
      return rules;
    },

    emailRules() {
      return [rules.required, rules.email];
    },

    phoneRules() {
      return [rules.required, rules.phoneNumber];
    },
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.isSubmitting = true;
          const requestData = { mobileNumber: this.phone, email: this.email };
          const response = await instituteService.submitContactDetails(requestData);

          // save contact details in session storage
          const newRegistration = JSON.stringify({
            email: this.email,
            phone: this.phone,
            emailRequestedAt: new Date(),
            smsRequestedAt: new Date(),
            registrationCode: response.data,
            referralCode: this.$route.query.referralCode,
          });
          sessionStorage.setItem("newRegistration", newRegistration);

          this.$router.push({ name: "Verification" });
        } catch (error) {
          console.log(error);
        } finally {
          this.isSubmitting = false;
        }
      }
    },
  },
};
</script>
